export default {
  init() {
    // JavaScript to be fired on all pages

    $(function () {

        console.log(window.SYSTEM_ENVIRONMENT_VARIABLES.WP_ENV);

        $('[data-toggle=tooltip]').tooltip();

        $('.box-curation .plus').click(function(){
          $(this).siblings('.description').toggleClass('show');
        });

        $('#carousel-mission').slick({
          slidesToShow: 4,
          dots: false,
          arrows: true,
          infinite: true,
          prevArrow: '<a class="slick-prev"><i class="fa fa-chevron-left"></i></a>',
          nextArrow: '<a class="slick-next"><i class="fa fa-chevron-right"></i></a>',
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 668,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });

        $('.books').slick({
            arrows: true,
            infinite: false,
            prevArrow: '<a class="slick-prev"><i class="fa fa-chevron-left"></i></a>',
            nextArrow: '<a class="slick-next"><i class="fa fa-chevron-right"></i></a>',
        });

        manageNavLinks();

        $('.nav-link,.dropdown-item').click(function(){
            manageNavLinks(this);
        });
    });

      function manageNavLinks(element) {
          if(element) {
              $('.nav-link,.dropdown-item').removeClass('line');
              $(element).addClass('line');
          } else {
              var url = location.pathname + location.hash;
              if (url.indexOf("/#how-works") >= 0){
                  $('.how-works-link').addClass('line');
              } else if (url.indexOf("/#in-kit") >= 0){
                  $('.in-kit-link').addClass('line');
              } else if (url.indexOf("/#choose-plan") >= 0){
                  $('.choose-plan-link').addClass('line');
              } else if (url.indexOf("/a-taba-na-escola/") >= 0){
                  $('.a-taba-na-escola-link').addClass('line');
              } else if (url.indexOf("/quem-somos/") >= 0){
                  $('.quem-somos-link').addClass('line');
              }
          }
      }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js